// extracted by mini-css-extract-plugin
export default {"anonymousAvatar":"_R5hJJ","withBorder":"eiqRsL","filter":"VC2Lg8"};